<script>
  import { images } from "./Images.js";
  export let id;
  export let naam;
  export let jobtitle;
  export let telefoon;
  export let email;
  export let addresses;

  export let location;
  // export let legaltext;
  //export let telefoonCleaned = telefoon.replace(/[a-z]/gi, "");
  export let extraInfo;
  //export let fontA = "'Open Sans', Roboto, 'Segoe UI', Arial, sans-serif";
  export let fontB = "Arial, Helvetica, sans-serif";
  // export let fontC = "";
  // export let fontColorDark = "#000000";
  export let fontColorGray = "gray";
  export let fontColorBlack = "black";
  // export let fontColorSilver = "#6C7F8E";
  //export let colorOrange = "#fd4024";
  //export let backgroundColor = "white";
  export let bannerLink = "";
  //  export let linkedinLink = "";
  // export let instagramLink = "";
  // export let vimeoLink = "";
  // export let email_name_generated = naam.replaceAll(' ', '.').toLowerCase();
</script>

<div id="{id}">
  <br />
  <br />
  <span style="font-size: 11pt;  font-family:inherit; color: {fontColorBlack}"
    >Groet,</span>

  <table
    id="signature-table"
    width="440"
    style="width: 440px;border-collapse: collapse; display:block; padding-top:20px "
    cellpadding="0"
    cellspacing="0"
    border="0">
    <tbody style="vertical-align: top;">
      <tr
        ><td
          width="200"
          colspan="1"
          style="height: 20px; padding-bottom: 4px; padding-top:8px"
          ><p
            style="margin: 0cm; line-height: 100%; font-size: 11pt;  font-family:{fontB};">
            <!-- svelte-ignore a11y-missing-attribute -->

            <span
              style="color: {fontColorBlack};  text-decoration:none !important; padding: 0cm;font-weight:bold; "
              >{naam}</span>
            <span> </span>
          </p></td>
        <td style="padding-top:9px; padding-left:8px">
          <p
            style="margin: 0cm; line-height: 100%; font-size: 11pt; font-family:{fontB};font-weight:regular;">
            <span
              ><span
                style="font-size: 11pt; color: {fontColorBlack}; text-decoration:none !important; padding: 0cm;"
                >{telefoon}</span
              ></span
            ><span><span style="font-size: 9pt;"><o:p>&nbsp;</o:p></span></span>
          </p>
        </td>
      </tr>
      <tr
        ><td width="200" colspan="1" style="height: 20px; padding-bottom: 4px;"
          ><p
            style="margin: 0cm; line-height: 100%; font-size: 11pt; font-weight:regular; font-family:{fontB};">
            <span
              ><span
                style="color: {fontColorBlack};  text-decoration:none !important; padding: 0cm;"
                >{jobtitle}</span
              ></span
            ><span
              ><span style="font-size: 9pt; color: {fontColorBlack};"
                ><o:p>&nbsp;</o:p></span
              ></span>
          </p></td>
        <td style=" padding-left:8px">
          <p
            style="margin: 0cm; line-height: 100%; font-size: 11pt;font-family:{fontB};font-weight:regular;">
            <span
              style="font-size: 11pt; color: {fontColorBlack} ;  text-decoration:none !important; padding: 0cm;"
              >{email}
            </span>
          </p>
        </td>
      </tr>

      <tr
        ><td width="200" colspan="1" style="height: 20px; padding-bottom: 4px;"
          ><p
            style="margin: 0cm; line-height: 100%; font-size: 9pt;;font-family:{fontB};font-weight:200;">
            {#if extraInfo !== ""}
              <span
                style="color: {fontColorGray};  text-decoration:none !important; padding: 0cm;"
                >{extraInfo}</span>
            {/if}
            <span
              ><span style="font-size: 9pt; color: {fontColorBlack};"
                ><o:p>&nbsp;</o:p></span
              ></span>
          </p></td>
        <td style=" padding-left:8px">
          <p
            style="margin: 0cm; line-height: 100%; font-size: 11pt; font-family:{fontB};font-weight:regular;">
            <span
              style="font-size: 11pt; color: {fontColorBlack} ;  text-decoration:none !important; padding: 0cm;"
              >{addresses[location].line1}</span>
          </p>
        </td>
      </tr>

      <tr
        ><td width="200" colspan="1" style="height: 20px; padding-bottom: 4px;"
          ><p
            style="margin: 0cm; line-height: 100%; font-size: 11pt;font-family:{fontB};font-weight:600;">
            <span
              style="color:#FF4126;  text-decoration:none !important; padding: 0cm;"
              ><a
                href="https://clarify.nl"
                target="_blank"
                style="color:#FF4126 !important;text-decoration:none"
                >clarify.nl</a
              ></span>

            <span
              ><span style="font-size: 9pt; color: {fontColorBlack};"
                ><o:p>&nbsp;</o:p></span
              ></span>
          </p></td>
        <td style=" padding-left:8px">
          <p
            style="margin: 0cm; line-height: 100%; font-size: 11pt; font-family:{fontB};font-weight:regular;">
            <span
              ><span
                style="font-size: 11pt; color: {fontColorBlack};  text-decoration:none !important; padding: 0cm;">
                {addresses[location].line2}</span
              ></span
            ><span><span style="font-size: 9pt;"><o:p>&nbsp;</o:p></span></span>
          </p>
        </td>
      </tr>

      <tr>
        <td colspan="2" style="padding-top:8px">
          <table
            style="border-collapse: collapse;border:none"
            cellpadding="0"
            cellspacing="0"
            border="0">
            <tbody style="vertical-align: ;top">
              <tr>
                <td
                  width="122"
                  valign="top"
                  border="0"
                  style="width: 122px;  height:68px;border:none;  padding:0;padding-right: 0;margin-right: 0;border-collapse: collapse;"
                  ><p
                    style="margin: 0cm;line-height: 0;font-size:0;margin-right: 0;padding-right: 0;">
                    <a href="https://www.clarify.nl/" target="_blank"
                      ><span
                        style="font-size: 0pt;color: rgb(51, 122, 183);padding: 0cm;margin: 0;margin-right: 0px;border-spacing: 0;"
                        ><img
                          alt="Clarify Logo"
                          width="122"
                          height="68"
                          src="{images.logo}"
                          style="margin-right: 0;padding-right: 0;" /></span
                      ></a>
                  </p>
                </td>
                <td
                  width="270px"
                  valign="top"
                  border="0"
                  style="width: 270px;padding: 0;border:none;border-collapse: collapse;">
                  <p style="margin:0cm;font-size:0pt">
                    <span
                      lang="EN-US"
                      style="color:{fontColorBlack};mso-color-alt:windowtext">
                      <a href="{bannerLink}" target="_blank">
                        <img
                          width="270"
                          height="68"
                          alt="Clarify Banner"
                          src="{images.banner}" />
                      </a></span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>
